<template>
  <div class="credman-panel">
    <b-card no-body>
      <b-tabs
        v-model="tabNum"
        card
      >
        <!-- app reg tab -->
        <b-tab
          title="App Registration"
          active
        >
          <b-button
            v-b-modal.app_reg_input
            @click.stop="getEnvOptions"
          >
            Add App Registration
          </b-button>
          <!-- app reg table -->
          <br>
          <hr>
          <b-card>
            <b-table
              outlined
              :items="items"
              :fields="fields"
              responsive
            >
              <template #cell(options)="row">
                <!-- <b-button
                  v-b-modal.app_reg_input
                  size="sm"
                  class="mr-2"
                  @click.stop="createAppRegHandler(row)"
                >
                  <font-awesome-icon icon="edit" />
                </b-button> -->
                <b-button
                  v-b-modal.deleteAppPrompt
                  variant="danger"
                  size="sm"
                  class="mr-2"
                  @click.stop="selectDeleteAppReg(row)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </b-button>
                <!-- <b-button
                  variant="success"
                  size="sm"
                  class="mr-2"
                  @click.stop="openSecretTab(row)"
                >
                  <font-awesome-icon icon="lock" />
                </b-button> -->
              </template>
            </b-table>
          </b-card>
        </b-tab>
        <!-- app secret table  wrapper-->
        <b-tab title="Secrets">
          <b-container fluid>
            <b-row>
              <b-col
                lg="4"
                class="my-1"
              >
                <b-button
                  v-b-modal.secretInput
                  @click.stop="parseEnvForSecret"
                >
                  Add App Secret
                </b-button>
              </b-col>
              <b-col
                lg="8"
                class="my-1"
              >
                <b-form-group
                  label="Select App Registration and Environment"
                  label-for="select-input"
                  label-cols-sm="4"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-select
                      v-model="selectedApp"
                      :options="appRegistrationList"
                      @change="setSecretEnvSearch"
                    />
                    <b-form-select
                      v-model="secretEnvForSearch"
                      :options="secretEnvOptions"
                    />

                    <b-input-group-append>
                      <b-button
                        @click.prevent="loadSecrets"
                      >
                        search
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- secret table -->
            <b-table
              :items="secretItems"
              :fields="secretFields"
              stacked="md"
              show-empty
              small
            >
              <template #cell(options)="row">
                <!-- <b-button
                  size="sm"
                  class="mr-2"
                  @click.stop="editSecretRow(row)"
                >
                  <font-awesome-icon icon="edit" />
                </b-button> -->
                <b-button
                  v-b-modal.deleteSecretPrompt
                  size="sm"
                  class="mr-2"
                  variant="danger"
                  @click.stop="deleteSecretRow(row)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </b-button>
              </template>
            </b-table>
          </b-container>
        </b-tab>
      </b-tabs>
    </b-card>
    <!-- app reg create form -->
    <b-modal
      id="app_reg_input"
      title="App Registration"
      @ok="createApp()"
      @cancel="resetAppRegValue"
      @close="resetAppRegValue"
    >
      <b-container fluid>
        <b-form>
          <b-form-group
            id="reg"
            label="App Registration Name"
            label-for="AppReg"
            :invalid-feedback="invalidFeedbacks.secretName"
            :state="validateRegistrationName"
          >
            <b-form-input
              id="appReg"
              v-model="createAppReg.appName"
              placeholder="Enter App Registration"
              required
            />
          </b-form-group>
          <b-form-group
            id="input-group-3"
            label="Environment"
            label-for="Environments"
          >
            <b-form-select
              id="Environments"
              v-model="createAppReg.env"
              :options="options"
            />
          </b-form-group>
        </b-form>
      </b-container>
    </b-modal>
    <!-- secret input form -->
    <b-modal
      id="secretInput"
      title="Secret Registration"
      @ok="createAppSecret()"
      @cancel="resetSecretValue"
      @close="resetSecretValue"
    >
      <b-container fluid>
        <b-form>
          <b-form-group
            id="secret"
            label="Secret"
            label-for="secret"
            :invalid-feedback="invalidFeedbacks.secretName"
            :state="validateSecretName"
          >
            <b-form-input
              id="secret"
              v-model="createSecret.secretName"
              placeholder="Enter Secret Name"
              required
            />
          </b-form-group>
          <b-form-group
            id="secApp"
            label="App Registration"
            label-for="appRegistration"
          >
            <b-form-select
              id="appSecretRegistion"
              v-model="createSecret.selectedAppReg"
              :options="appRegistrationList"
              @change="setSecretEnv"
            />
          </b-form-group>
          <b-form-group
            id="secEnv"
            label="Environments"
            label-for="secretEnv"
          >
            <b-form-select
              id="secretEnv"
              v-model="createSecret.selectedSecretEnv"
              :options="secretEnvOptions"
            />
          </b-form-group>
        </b-form>
      </b-container>
    </b-modal>
    <!-- end -->
    <!-- secret delete prompt modal -->
    <b-modal
      id="deleteSecretPrompt"
      title="Delete Secret"
      @ok="deleteSecret"
    >
      <h6> Are you sure you want to delete the Secret Entry?</h6>
    </b-modal>
    <b-modal
      id="deleteAppPrompt"
      title="Delete App Registration"
      @ok="deleteAppReg()"
    >
      <h6> Are you sure you want to delete the App Registration Entry?</h6>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api';
import {capitalize} from 'lodash';
import toastr from 'toastr';
window.toastr = toastr;

export default {
  name: 'CredManPanel',
  components: {
  },
  props: {
    project: {
      type: Object,
      required: true,
      validator: (value) => !!value.projectName,
    },
    projenv: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterOn: ['ObjectId'],
      tabNum: 0,
      popUp: '',
      inProgress: false,
      importing: false,
      readiness: 'unknown',
      allEnvironments: [],
      secretEnvForSearch: '',
      options: [],
      selectedApp: '',
      filter: null,
      secretDetails: {},
      secretEnvOptions: [],
      selectedAppRegRow: {},
      appRegistrationList: [],
      appRegDetails: {},
      selectedEnv: [],
      appregToSecret: {},
      currentSecretAppEnv: {},
      parsedSecretEnvList: {},
      createAppReg: {
        appName: '',
        env: [],
      },
      createSecret: {
        secretName: '',
        selectedSecretEnv: {},
        selectedAppReg: '',
      },
      fields: [
        {key: 'appRegistrationName', sortable: true},
        {key: 'spObjectId', sortable: true},
        {key: 'createdBy', sortable: true},
        {key: 'azureEnvironment', sortable: true},
        {key: 'options'},
      ],
      items: [],
      secretFields: [
        {key: 'secretName'},
        {key: 'createdBy'},
        {key: 'createdOn'},
        {key: 'expiresOn'},
        {key: 'options'},
      ],
      secretItems: [],
      invalidFeedbacks: {
        registrationName: 'Sorry, space and special characters ("/[]:|<>+=;?*,.) are not allowed.',
        duplicateRegistrion: 'Sorry, Registraion Name is Present in the Same Environment ',
        secretName: 'Sorry, space and special characters ("/[]:|<>+=;?*,.) are not allowed.',
      },
    };
  },
  computed: {
    state() {
      return this.isValid();
    },
    validateRegistrationName() {
      const pn = this.createAppReg.appName;
      const nameRegex = /^[a-zA-Z0-9]{1}((?![~@%#$'"{}/\\[\]:|<>+=;?*,\s]).)*$/g;
      if (pn.length === 0) {
        return null;
      } else if (pn.endsWith('.') || pn.match(nameRegex) === null) {
        return false;
      } else {
        return true;
      }
    },
    validateSecretName() {
      const pn =this.createSecret.secretName;
      const nameRegex = /^[a-zA-Z0-9]{1}((?![~@%#$'"{}/\\[\]:|<>+=;?*,\s]).)*$/g;
      if (pn.length === 0) {
        return null;
      } else if (pn.endsWith('.') || pn.match(nameRegex) === null) {
        return false;
      } else {
        return true;
      }
    },
    envToggle() {
      if (this.secretEnvOptions&&this.secretEnvOptions.length>1) {
        return true;
      } else {
        return false;
      }
    },
    invalidFeedback() {
      return '';
    },
    validFeedback() {
      // const repositoryName = getRepositoryName(this.repositoryNameInput);
      return `The repository's name will be: ${this.project.projectName}`;
    },
  },
  async created() {
    // console.log(this.project);
    this.items = await this.getApps();
    this.transformEnvForAppReg();
    this.setAppList();
    this.parseEnvFromProps();
  },
  beforeDestroy() {
    if (this.pollingReadiness) {
      clearInterval(this.pollingReadiness);
    }
  },
  methods: {
    setSecretEnv() {
      this.secretEnvOptions = [];
      this.createSecret.selectedSecretEnv={};
      this.parseEnvForSecret();

      if (this.createSecret.selectedAppReg!='') {
        this.secretEnvOptions=this.parsedSecretEnvList[this.createSecret.selectedAppReg];
      } else {
        return this.secretEnvOptions=[];
      }
    },
    setSecretEnvSearch() {
      this.secretEnvOptions = [];
      this.parseEnvForSecret();
      if (this.selectedApp!='') {
        this.secretEnvOptions=this.parsedSecretEnvList[this.selectedApp];
      } else {
        return this.secretEnvOptions=[];
      }
    },
    setAppList() {
    // console.log('generation app list');
    // console.log(this.items);
      const appList = this.items.map((o)=>o.appRegistrationName);
      this.appRegistrationList = Array.from(new Set(appList));
    },
    async showTab(tabIndex) {
      // Fetch readiness every time a tab is shown or switched.
      await this.getReadiness();
    },
    async loadSecrets() {
      // this.parseEnvForSecret();
      if (this.selectedApp!='' && this.secretEnvForSearch!='') {
        const environment = this.secretEnvForSearch;
        const data = {
          appRegistrationName: this.selectedApp,
          environment: environment.partnerEnvironmentKey,
        };
        const secrets = await api.getSecretDetails(data);
        this.secretItems = secrets;
        this.currentSecretAppEnv = {
          appRegistrationName: this.selectedApp,
          environment: environment.partnerEnvironmentKey,
        };
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async createApp() {
      const data = {
        appRegistrationName: this.createAppReg.appName,
        environment: this.createAppReg.env.partnerEnvironmentKey,
        projectName: this.project.projectName,
      };
      try {
        await api.createApp(data);
        this.items=await this.getApps();
        this.transformEnvForAppReg();
        this.setAppList();
        this.resetAppRegValue();
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          this.popUp = 'Error: ' + err.response.data.error;
        } else {
          this.popUp = 'Some error occured while creating app registration';
        }
        this.failFeedback();
      }
    },
    async getApps() {
      const response = await api.getApps(this.project.projectName);
      return response;
    },
    async deleteSecret() {
      const data = {
        secretName: this.secretDetails.secretName,
        appRegistrationName: this.currentSecretAppEnv.appRegistrationName,
        projectName: this.project.projectName,
        environment: this.currentSecretAppEnv.environment,
      };
      await api.deleteSecretApi(data);
    },
    async editSecretRow(row) {
      // console.log(row);
      // call edit secret api below
    },
    getEnvOptions() {
      // this.options = this.project.environments.map((e)=>{
      //   const env = JSON.parse(e);
      //   return {
      //     key: `${env.env}:${env.cloud}:${env.subEnvironment}`,
      //     text: `${capitalize(env.env)} - ${capitalize(env.subEnvironment)}`,
      //     value: {...env, partnerEnvironmentKey: `${env.env}:${env.cloud}:${env.subEnvironment}`},
      //   };
      // });
      // console.log('get env options');
      this.parseEnvFromProps();
      this.options = [];
      // console.log(this.project.environments);
      const preEnv = this.project.environments.map((e)=>{
        const env = JSON.parse(e);
        return {
          key: `${env.env}:${env.cloud}:${env.subEnvironment}`,
          text: `${env.env} - ${env.subEnvironment}`,
          value: {...env, partnerEnvironmentKey: `${env.env}:${env.cloud}:${env.subEnvironment}`},
        };
      });
      console.log('all env>>', this.allEnvironments);
      for (const item of preEnv) {
        for (const env of this.allEnvironments) {
          if ( (env.key==item.key) && !env.key.includes('infra2_0') && !this.options.find((o)=>o.text == env.text)) {
            // if (env.tenant.toLowerCase() == 'us gov' || env.tenant.toLowerCase() == 'us commercial') {
            this.options.push(env);
            // }
          }
        }
      }
      console.warn('options >>', this.options);
    },
    async createAppSecret() {
      const data = {
        secretName: this.createSecret.secretName,
        appRegistrationName: this.createSecret.selectedAppReg,
        projectName: this.project.projectName,
        environment: this.createSecret.selectedSecretEnv.partnerEnvironmentKey,
      };
      try {
        await api.createSecret(data);
        this.resetSecretValue();
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          this.popUp = 'Error: ' + err.response.data.error;
        } else {
          this.popUp = 'Some error occured while creating app secret';
        }
        this.failFeedback();
      }
    },
    parseEnvForSecret() {
      const parsedEnv={};
      this.getEnvOptions();
      this.items.forEach((item)=>{
        const obj =this.options.find((env)=>env.key==item.environment);
        if (!Object.prototype.hasOwnProperty.call(parsedEnv, item.appRegistrationName)) {
          parsedEnv[item.appRegistrationName]=[obj];
        } else {
          parsedEnv[item.appRegistrationName].push(obj);
        }
      });
      this.parsedSecretEnvList = parsedEnv;
    },
    // async createAppRegHandler(row) {
    //   this.getEnvOptions();
    // },
    selectDeleteAppReg(row) {
      Object.assign(this.selectedAppRegRow, row.item);
    },
    async deleteAppReg() {
      const data = {
        appRegistrationName: this.selectedAppRegRow.appRegistrationName,
        appRegistrationId: this.selectedAppRegRow.objectId,
        projectName: this.project.projectName,
        environment: this.selectedAppRegRow.environment,
      };
      await api.deleteApp(data);
    },
    deleteSecretRow(row) {
      Object.assign(this.secretDetails, row.item);
      row.toggleDetails();
    },
    // openSecretTab(row) {
    //   // make api call to load the app secret data in here
    //   const apiMockResponse = {
    //     SecretName: '123',
    //     AppRegName: 'Mickey',
    //     CreatedOn: '06-12-2022',
    //   };
    //   this.secretItems =[apiMockResponse];
    //   this.tabNum=1;
    // },
    resetAppRegValue() {
      this.createAppReg= {
        appName: '',
        env: [],
      };
    },
    resetSecretValue() {
      this.createSecret={
        secretName: '',
        selectedSecretEnv: {},
        selectedAppReg: '',
      };
    },
    // failer show
    failFeedback() {
      this.$toastr.error(this.popUp, '', {
        positionClass: 'toast-bottom-center',
        timeOut: '200000',
        toastClass: 'toast-style',
      });
    },
    transformEnvForAppReg() {
      this.parseEnvFromProps();
      this.items.forEach((item)=>{
        const strArr = item.environment.split(':');
        item['azureEnvironment'] = strArr[1];
        // console.log(this.allEnvironments);
        // for (const env of this.allEnvironments) {
        // // console.log('key', env);
        //   if (item.environment == env.value.partnerEnvironmentKey) {
        //     item.tenant = env.tenant;
        //   }
        // }
      });
      // this.items = this.items.filter((item)=>{
      //   if (item.tenant.toLowerCase() == 'us commercial' || item.tenant.toLowerCase() == 'us gov') {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // });
    },
    parseEnvFromProps() {
      // console.log('props env called');
      // console.log(this.projenv);
      this.allEnvironments = [];
      for (const grandParent of this.projenv) {
        const lable = grandParent.label;
        for (const parent of grandParent.children) {
          const envOptions =parent.children.map((chd)=>{
            const env = JSON.parse(chd.id);
            const subEnvArr =env.subEnvironment.split(':');
            const subEnv = subEnvArr[2]??'';
            // if (lable.toLowerCase() =='us commercial' || lable.toLowerCase()=='us gov') {
            return {

              key: `${env.env}:${env.cloud}:${env.subEnvironment}`,
              text: `${capitalize(env.env)} - ${subEnv} ${lable}`,
              value: {...env, partnerEnvironmentKey: `${env.env}:${env.cloud}:${env.subEnvironment}`},
              tenant: lable,
            };
            // }
          });
          // console.log('parent options', envOptions);
          this.allEnvironments.push(...envOptions);
        }
      }
    },
  },
};
</script>
